import { userClient } from "lib/clients";
import useSWR from "swr";

const fetcher = async () => {
  const { data } = await userClient.getTeams();
  return data;
}

export const useUserTeams = (config = {}) => {
  const { data, error, isValidating, mutate } = useSWR('/v1/user/teams', fetcher, { ...config, fallbackData: [] });

  return {
    data,
    isValidating,
    isLoading: !data && !error,
    error,
    mutate,
  };
};
